import { render } from "./total_due_display.vue?vue&type=template&id=5b6a4e7b"
import script from "./total_due_display.vue?vue&type=script&lang=js"
export * from "./total_due_display.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__